class blogFilter extends HTMLElement {
    constructor() {
        super();
        this.mainBlog = document.querySelector("[js-main-blog]");
        this.scrollToElement = this.mainBlog.querySelector("[data-scroll-to]");
        this.dropdownBtn = this.querySelector("[js-dropdown-btn]");
        this.sectionId = this.mainBlog.dataset.sectionId;
        
        this.init();

        document.addEventListener("scroll:init", this.updateScroll.bind(this));
        document.addEventListener("loading:init", ({ detail: { loading }}) => {
            this.updateLoading(loading);
        });
        document.addEventListener("updateHistoryState", ({ detail: { url }}) => {
            this.updateHistoryState(url);
        });
    };

    init() {
        this.filterItems = this.querySelectorAll("[js-filter-item]");

        this.filterItems.forEach( filterItem => {
            filterItem.addEventListener('click', (e) => {
                e.preventDefault();

                this.initAjaxBlog(e.currentTarget);
            })
        });

        this.dropdownBtn.addEventListener("click", (e) => {
            const dropdown = e.currentTarget.closest("[js-dropdown]");
            this.toggleDropdown(dropdown);
        });

        document.addEventListener("click", (e) => {
            const dropdown = this.querySelector("[js-dropdown]");
            if(dropdown.classList.contains('active') && !dropdown.contains(e.target)) {
                this.closeDropdown(dropdown);
            };
        });
    };

    toggleDropdown(dropdown) {
        dropdown.classList.toggle("active");
    };

    closeDropdown(dropdown) {
        dropdown.classList.remove("active");
    };

    initAjaxBlog(target) {
        const tagUrl = target.querySelector("a").getAttribute("href");

        this.closeDropdown(this.querySelector("[js-dropdown]"));
        this.updateLoading(true);
        if(!target.classList.contains("is-remove-item")) {
            this.changeActiveState(target);
        };
        this.updateHistoryState(tagUrl);
        this.renderAjaxBlog(tagUrl);
    };

    updateLoading(loading) {
        if(loading) {
            this.scrollToElement.classList.add('loading');
        }else {
            this.scrollToElement.classList.remove('loading');
        }
    };

    changeActiveState(target) {
        this.filterItems.forEach( filterItem => {
            filterItem.classList.add('disabled')
        });
        target.classList.add('active');
    };

    updateHistoryState(TagUrl) {
        var newurl = `${window.location.protocol}//${window.location.host}${TagUrl}`;
        window.history.replaceState({path: newurl}, '', newurl);
    };

    updateScroll() {
        var scrollTo = this.scrollToElement && this.scrollToElement.offsetTop;
        window.scrollTo({top: scrollTo, behavior: 'smooth'});
    };

    renderAjaxBlog(tagUrl) {
        const url = `${tagUrl}?section_id=${this.sectionId}`;
        
        fetch(url).then(function(response) {
            return response.text();
        }).then((html) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            this.updateScroll();
            this.mainBlog.innerHTML = doc.querySelector("[js-main-blog]").innerHTML;
            this.updateLoading(false);
        });
    }
}
  
customElements.define('blog-filter', blogFilter);